import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import CustomInvoiceBuilder from '../../components/vendor/invoice/CustomInvoiceBuilder';

const VendorInvoiceEdit = () => {
  return (
    <div className="space-y-6">
      <div>
        <Link
          to="/vendor/invoices"
          className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to invoices
        </Link>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Edit invoice</h1>
        <p className="text-sm text-gray-600 mt-1">
          Update line items, dates, tax, and notes. Paid or cancelled invoices cannot be edited.
        </p>
      </div>
      <CustomInvoiceBuilder />
    </div>
  );
};

export default VendorInvoiceEdit;
